const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5036",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.026,
    height: 69.566,
    viewBox: "0 0 107.026 69.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fn0ep1143a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3415",
    style: {
      fill: "none"
    },
    d: "M0 0h107.026v69.566H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5036",
    style: {
      clipPath: "url(#fn0ep1143a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13782",
    d: "M27.647 74.359a7.135 7.135 0 1 0 7.135 7.135 7.135 7.135 0 0 0-7.135-7.135",
    transform: "translate(-6.242 -22.63)",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13783",
    d: "M31.251 46.1V32.618h-15.31L7.276 46.1h23.975z",
    transform: "translate(-2.214 -9.927)",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13784",
    d: "M114.833 74.36a7.135 7.135 0 0 0-7.138 7.131 7.135 7.135 0 1 0 7.138-7.134",
    transform: "translate(-32.775 -22.63)",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13785",
    d: "M17.044 26.425h14.622a1.783 1.783 0 0 1 1.784 1.782v16.056a1.782 1.782 0 0 1-1.781 1.784H4.91V45.3l-.5.772V64.38h7.718a10.694 10.694 0 0 1 21.233 0h3.653V22.359H19.658z",
    transform: "translate(-1.343 -6.804)",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13786",
    d: "M55.7 15.611V58.92h32.685a10.693 10.693 0 0 1 21.233 0H120.9V4.414H55.695v11.2z",
    transform: "translate(-16.95 -1.343)",
    style: {
      fill: "#f8f8f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13787",
    d: "M17.168 82.763h-1.7a9.836 9.836 0 0 0 .074 3.071h1.623z",
    transform: "translate(-4.682 -25.187)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13788",
    d: "M45.288 82.759h-1.7v3.071h1.622a9.953 9.953 0 0 0 .074-3.071",
    transform: "translate(-13.266 -25.186)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13789",
    d: "M5.127 52v2.326L6.622 52z",
    transform: "translate(-1.56 -15.824)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13790",
    d: "m19.86 28.2-1.491 3.071h.948l1.974-3.071z",
    transform: "translate(-5.59 -8.583)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13791",
    d: "M54.353 64.321V19.714a1.782 1.782 0 0 0-1.782-1.769h-1.29v46.382a1.55 1.55 0 1 0 3.072-.006",
    transform: "translate(-15.606 -5.461)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13792",
    d: "M132.465 82.764h-1.7v3.071h1.622a9.9 9.9 0 0 0 .076-3.071",
    transform: "translate(-39.796 -25.187)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13793",
    d: "M104.346 82.764h-1.7a9.835 9.835 0 0 0 .074 3.071h1.623z",
    transform: "translate(-31.213 -25.187)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13794",
    d: "M26.086 69.23a10.7 10.7 0 1 1-10.7 10.7 10.7 10.7 0 0 1 10.7-10.7m0 17.838a7.135 7.135 0 1 0-7.135-7.135 7.135 7.135 0 0 0 7.135 7.135z",
    transform: "translate(-4.682 -21.069)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13795",
    d: "m.283 43.738 16.054-24.974a1.784 1.784 0 0 1 1.5-.819h19.126a1.783 1.783 0 0 1 1.784 1.782v44.594a1.782 1.782 0 0 1-1.781 1.779h-6.641v-3.066h5.351V21.016H18.314L3.071 44.73v18.307h9.415v3.071H1.784A1.782 1.782 0 0 1 0 64.328V44.706a1.782 1.782 0 0 1 .283-.968",
    transform: "translate(0 -5.461)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13796",
    d: "M30.6 44.755v-13.48H14.339L15.83 28.2h16.053a1.783 1.783 0 0 1 1.784 1.782v16.06a1.782 1.782 0 0 1-1.781 1.784H5.127v-3.071H30.6z",
    transform: "translate(-1.56 -8.583)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13797",
    d: "M53.065 0h67.783a1.785 1.785 0 0 1 1.784 1.784v57.08a1.783 1.783 0 0 1-1.782 1.784h-14.273v-3.071h12.983V3.071H54.352v54.506h34.387v3.071H53.065a1.782 1.782 0 0 1-1.784-1.781V1.784A1.783 1.783 0 0 1 53.063 0z",
    transform: "translate(-15.606)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13798",
    d: "M113.264 69.231a10.7 10.7 0 1 1-10.7 10.7 10.7 10.7 0 0 1 10.7-10.7m0 17.838a7.135 7.135 0 1 0-7.131-7.138 7.142 7.142 0 0 0 7.131 7.138z",
    transform: "translate(-31.213 -21.069)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3414",
    transform: "translate(1.784 50.442)",
    style: {
      fill: "#313280"
    },
    d: "M0 0h7.135v3.071H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.1620d499bdb15dd909aba7ddb7ba7983.svg";
export { ForwardRef as ReactComponent };